export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        excelImportFormIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            checkbox_rows: true,
            global_search: {
                visibility: false,
            }
        },
        excelImportHeaderFields: [
            {
                name: "fileData",
                label: "Feltöltés...",
                formType: "xlsFileInput",
                fileSize: "1024",
                formRequired: true,
                formSize: 4,
                visibility: false,
                formVisible: true,
            },
        ],
        excelImportFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGridFromExcelImport',
            }, 
            {
                btn_text: '<i class="fas fa-check"></i> Adatellenőrzés',
                event_name: "customClick",
                class: "btn btn-info mx-1",
                event_payload: 'validateXls',
            },
        ],
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új labortípus',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'export',
                additionalButtonVisible:'labTreatmentExcelImportExportVisible'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új Excel feltöltése',
                event_name: "customClick",
                class: "btn btn-purple",
                event_payload: 'import',
                additionalButtonVisible:'labTreatmentExcelImportExportVisible'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Árajánlat nyomtatása',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'print'
            },
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "isSynlabType",
                label: "",
                visibility: true,
                slot_name: 'is_synlab_type_icon',
            },
            {
                name: "title",
                label: "Labortípus neve",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "code",
                label: "Labortípus kódja",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: 'tooltip_for_laboratory_types',
            },
            {
                name: "price",
                label: "Labortípus ára",
                filter: {
                    type: "simple",
                },
                slot_name: 'treatment_price_format',
                visibility: true,
            },
            {
                name: "comment",
                label: "Megjegyzés",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "teszorCode",
                label: "TESZOR kód",
                filter: {
                    type: "simple",
                },
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                formVisible: false
            }
        ],
        formHeaderFields: [
            {
                name: "kaszCode",
                label: "KASZ kód",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 4,
                formRequired: false,
            },
            {
                name: "comment",
                label: "Megjegyzés",
                formVisible: true,
                formSize: 4,
                formType: "textarea",
            },
        ],
    }
}
